export default "__VITE_ASSET__DOZrAqZd__"